import React, { useEffect, useState } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {
  BootstrapActions,
  BootstrapContent,
  BootstrapDialog,
  BootstrapDialogTitle,
} from "../../components/dialog";
import { useTranslation } from "react-i18next";
function ViewPhoto(props) {
  const { open, setOpen, productImages = [] } = props;
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (open) {
      setCurrentIndex(0);
    }
  }, [open, productImages]);

  const hasImages = productImages.length > 0;
  const showControls = productImages.length > 1;
  const currentImage = hasImages ? productImages[currentIndex] : "";

  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? productImages.length - 1 : prev - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prev) =>
      prev === productImages.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <>
      <BootstrapDialog
        open={open}
        fullWidth={true}
        onClose={() => setOpen(false)}
      >
        <BootstrapDialogTitle onClose={() => setOpen(false)}>
          <Typography variant="h4" component="p">
            {t("LVLDB0040")}
          </Typography>
        </BootstrapDialogTitle>
        <BootstrapContent>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              height: { xs: 360, sm: 520 },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: "#fafafa",
            }}
          >
            {hasImages ? (
              <>
                <img
                  id="snapImage"
                  src={currentImage}
                  alt={`${t("LVLDB0040")} ${currentIndex + 1}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
                {showControls && (
                  <>
                    <IconButton
                      aria-label="Previous photo"
                      onClick={handlePrev}
                      sx={{
                        position: "absolute",
                        left: 8,
                        top: "50%",
                        transform: "translateY(-50%)",
                        bgcolor: "rgba(255, 255, 255, 0.85)",
                        "&:hover": {
                          bgcolor: "rgba(255, 255, 255, 0.95)",
                        },
                      }}
                    >
                      <ChevronLeftIcon />
                    </IconButton>
                    <IconButton
                      aria-label="Next photo"
                      onClick={handleNext}
                      sx={{
                        position: "absolute",
                        right: 8,
                        top: "50%",
                        transform: "translateY(-50%)",
                        bgcolor: "rgba(255, 255, 255, 0.85)",
                        "&:hover": {
                          bgcolor: "rgba(255, 255, 255, 0.95)",
                        },
                      }}
                    >
                      <ChevronRightIcon />
                    </IconButton>
                    <Typography
                      sx={{
                        position: "absolute",
                        right: 12,
                        bottom: 12,
                        px: 1,
                        py: 0.25,
                        borderRadius: 1,
                        color: "#fff",
                        bgcolor: "rgba(0, 0, 0, 0.55)",
                      }}
                      variant="body2"
                    >
                      {currentIndex + 1} / {productImages.length}
                    </Typography>
                  </>
                )}
              </>
            ) : (
              <Typography variant="body1">{t("LVL0028")}</Typography>
            )}
          </Box>
        </BootstrapContent>
        <BootstrapActions></BootstrapActions>
      </BootstrapDialog>
    </>
  );
}

export default ViewPhoto;
